import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import { useState } from "react";
import { toast } from "sonner";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useUploadMediaFileMutation } from "MusicAudio/Api/Mutations/useUploadMediaFileMutation";
import type { UploadMediaFileFormData } from "MusicAudio/Forms/uploadMediaFileFormSchema";
import { UploadMediaFileModal } from "./UploadMediaFileModal";

export const UploadMediaFileButton = (): React.ReactNode => {
  const { t } = useResource();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const uploadMutation = useUploadMediaFileMutation();

  const handleUpload = async (formData: UploadMediaFileFormData) => {
    try {
      await uploadMutation.mutateAsync({
        file: formData.file,
        displayName: formData.displayName,
        licenseConfirmed: formData.licenseConfirmed,
      });
      toast.success(t(Resources.MusicAudio.UploadModal.SuccessMessage));
      setIsModalOpen(false);
    } catch {
      // error handled by hook
    }
  };

  return (
    <>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => setIsModalOpen(true)}
        sx={{ px: Spacing.L }}
      >
        {t(Resources.MusicAudio.UploadModal.Upload)}
      </Button>
      <UploadMediaFileModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleUpload}
      />
    </>
  );
};
